var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132px",
    height: "80px",
    viewBox: "0 0 132 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "5.97144466 74.0625 27.1940179 74.0625 27.1940179 38.1851945 123.681319 38.1851945 123.681319 9.01824373 0.456739075 6.57807142e-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.5958389%",
    y1: "8.50799268%",
    x2: "66.2740229%",
    y2: "90.3188057%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E7E8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "0.267751342 0.266582885 5.85594844 0.266582885 5.85594844 6.66346154 0.267751342 6.66346154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "0 0.208940118 13.9760632 0.208940118 13.9760632 3.62696301 0 3.62696301"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OpsTools/Stores/Store",
    transform: "translate(-63.000000, -352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(39.000000, 302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.375000, 50.625000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy-2",
    transform: "translate(2.355761, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#5F5654",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(31.875000, 40.312500)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 0,
    width: 21.5625,
    height: 33.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(0.000000, 5.625000)",
    fill: "#D9E4E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7602958,8.94159222 L12.7665309,8.94876479 C13.1829783,9.43187386 13.1320371,10.1603933 12.6524087,10.5808448 L1.40515454,20.4404063 C1.00192149,20.7938883 0.420055746,20.8127079 -0.000910409894,20.5191881 L-1.14504391e-05,18.6080536 L11.1479705,8.83558797 C11.6224741,8.41962888 12.3443367,8.4670886 12.7602958,8.94159222 Z M21.2434729,7.58637711 L21.2429885,10.5050536 L11.0614045,19.4308893 C10.5869009,19.8468484 9.86503827,19.7993887 9.44907918,19.3248851 C9.44699089,19.3225029 9.44491252,19.320112 9.44284412,19.3177125 C9.02639668,18.8346034 9.07733794,18.106084 9.55696629,17.6856325 L20.8042205,7.82607093 C20.9355913,7.7109087 21.0859225,7.63126807 21.2434729,7.58637711 Z M13.7259208,0.865455852 C13.7280091,0.867838055 13.7300875,0.870228933 13.7321559,0.872628424 C14.1486033,1.35573749 14.0976621,2.08425692 13.6180337,2.50470846 L2.37077954,12.36427 C1.89627592,12.7802291 1.17441327,12.7327694 0.758454177,12.2582657 L0.752219125,12.2510932 C0.335771677,11.7679841 0.386712939,11.0394647 0.866341291,10.6190131 L12.1135955,0.759451608 C12.5880991,0.343492517 13.3099617,0.390952233 13.7259208,0.865455852 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(54.375000, 40.312500)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 0,
    width: 21.5625,
    height: 33.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(0.000000, 5.625000)",
    fill: "#D9E4E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7602958,8.94159222 L12.7665309,8.94876479 C13.1829783,9.43187386 13.1320371,10.1603933 12.6524087,10.5808448 L1.40515454,20.4404063 C1.00192149,20.7938883 0.420055746,20.8127079 -0.000910409894,20.5191881 L-1.14504391e-05,18.6080536 L11.1479705,8.83558797 C11.6224741,8.41962888 12.3443367,8.4670886 12.7602958,8.94159222 Z M21.2434729,7.58637711 L21.2429885,10.5050536 L11.0614045,19.4308893 C10.5869009,19.8468484 9.86503827,19.7993887 9.44907918,19.3248851 C9.44699089,19.3225029 9.44491252,19.320112 9.44284412,19.3177125 C9.02639668,18.8346034 9.07733794,18.106084 9.55696629,17.6856325 L20.8042205,7.82607093 C20.9355913,7.7109087 21.0859225,7.63126807 21.2434729,7.58637711 Z M13.7259208,0.865455852 C13.7280091,0.867838055 13.7300875,0.870228933 13.7321559,0.872628424 C14.1486033,1.35573749 14.0976621,2.08425692 13.6180337,2.50470846 L2.37077954,12.36427 C1.89627592,12.7802291 1.17441327,12.7327694 0.758454177,12.2582657 L0.752219125,12.2510932 C0.335771677,11.7679841 0.386712939,11.0394647 0.866341291,10.6190131 L12.1135955,0.759451608 C12.5880991,0.343492517 13.3099617,0.390952233 13.7259208,0.865455852 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-2",
    transform: "translate(77.812500, 40.312500)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 0,
    width: 21.5625,
    height: 33.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(0.000000, 5.625000)",
    fill: "#D9E4E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7602958,8.94159222 L12.7665309,8.94876479 C13.1829783,9.43187386 13.1320371,10.1603933 12.6524087,10.5808448 L1.40515454,20.4404063 C1.00192149,20.7938883 0.420055746,20.8127079 -0.000910409894,20.5191881 L-1.14504391e-05,18.6080536 L11.1479705,8.83558797 C11.6224741,8.41962888 12.3443367,8.4670886 12.7602958,8.94159222 Z M21.2434729,7.58637711 L21.2429885,10.5050536 L11.0614045,19.4308893 C10.5869009,19.8468484 9.86503827,19.7993887 9.44907918,19.3248851 C9.44699089,19.3225029 9.44491252,19.320112 9.44284412,19.3177125 C9.02639668,18.8346034 9.07733794,18.106084 9.55696629,17.6856325 L20.8042205,7.82607093 C20.9355913,7.7109087 21.0859225,7.63126807 21.2434729,7.58637711 Z M13.7259208,0.865455852 C13.7280091,0.867838055 13.7300875,0.870228933 13.7321559,0.872628424 C14.1486033,1.35573749 14.0976621,2.08425692 13.6180337,2.50470846 L2.37077954,12.36427 C1.89627592,12.7802291 1.17441327,12.7327694 0.758454177,12.2582657 L0.752219125,12.2510932 C0.335771677,11.7679841 0.386712939,11.0394647 0.866341291,10.6190131 L12.1135955,0.759451608 C12.5880991,0.343492517 13.3099617,0.390952233 13.7259208,0.865455852 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(101.250000, 40.312500)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    x: 0,
    y: 0,
    width: 21.5625,
    height: 33.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(0.000000, 5.625000)",
    fill: "#D9E4E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7602958,8.94159222 L12.7665309,8.94876479 C13.1829783,9.43187386 13.1320371,10.1603933 12.6524087,10.5808448 L1.40515454,20.4404063 C1.00192149,20.7938883 0.420055746,20.8127079 -0.000910409893,20.5191881 L-1.14504391e-05,18.6080536 L11.1479705,8.83558797 C11.6224741,8.41962888 12.3443367,8.4670886 12.7602958,8.94159222 Z M21.2434729,7.58637711 L21.2429885,10.5050536 L11.0614045,19.4308893 C10.5869009,19.8468484 9.86503827,19.7993887 9.44907918,19.3248851 C9.44699089,19.3225029 9.44491252,19.320112 9.44284412,19.3177125 C9.02639668,18.8346034 9.07733794,18.106084 9.55696629,17.6856325 L20.8042205,7.82607093 C20.9355913,7.7109087 21.0859225,7.63126807 21.2434729,7.58637711 Z M13.7259208,0.865455852 C13.7280091,0.867838055 13.7300875,0.870228933 13.7321559,0.872628424 C14.1486033,1.35573749 14.0976621,2.08425692 13.6180337,2.50470846 L2.37077954,12.36427 C1.89627592,12.7802291 1.17441327,12.7327694 0.758454177,12.2582657 L0.752219125,12.2510932 C0.335771677,11.7679841 0.386712939,11.0394647 0.866341291,10.6190131 L12.1135955,0.759451608 C12.5880991,0.343492517 13.3099617,0.390952233 13.7259208,0.865455852 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5F5654",
    x: 0,
    y: 75.9375,
    width: 131.25,
    height: 2.8125
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5F5654",
    x: 121.875,
    y: 35.390625,
    width: 9.375,
    height: 2.8125
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy-3",
    transform: "translate(3.750000, 15.937500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#EE7102",
    points: "0.247848975 0 122.338347 0 122.338347 3.75 0.527394289 3.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#EC2526",
    points: "1.08465672 11.25 122.338347 11.25 122.338347 15 1.36339188 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    fill: "#41A44B",
    points: "0.668635368 5.625 122.338347 5.625 122.338347 9.375 0.948443413 9.375"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(59.062500, 10.312500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.46875,0 L24.375,0 C24.892767,-9.51122462e-17 25.3125,0.419733047 25.3125,0.9375 L25.3125,22.5 C25.3125,23.017767 24.892767,23.4375 24.375,23.4375 L0.9375,23.4375 C0.419733047,23.4375 6.34081642e-17,23.017767 0,22.5 L0,0.46875 C-3.17040821e-17,0.209866524 0.209866524,4.75561231e-17 0.46875,0 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(5.625000, 1.875000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L11.4257812,0.0120422492 C10.290665,0.561971631 6.86948811,3.64729624 6.01287485,5.71153846 L0.0113059383,5.71153846 L0,0 Z",
    id: "Fill-1",
    fill: "#EE7102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2734375,8.56730769 L9.8799118,8.56730769 C10.268033,7.27034217 11.7464661,5.54132349 13.1835938,5.04559086 L13.1835938,0 C8.91091115,2.04177357 6.06865808,5.08952164 5.2734375,8.56730769",
    id: "Fill-3",
    fill: "#EE7102"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(4.394531, 12.375000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85594844,0.266582885 C5.67788549,2.09681365 5.67014362,4.32196558 5.66769882,6.66350596 L0.268357569,6.66350596 C0.259393302,4.52853288 0.349850909,2.39444827 0.539322925,0.269248269 L5.85594844,0.266582885 Z",
    id: "Fill-5",
    fill: "#EE7102",
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 8.567308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03134166,1.01380431 L6.01207149,1.01579815 C5.74970068,1.02045046 5.50030018,1.11549046 5.31908644,1.28064738 C5.1378727,1.44580431 5.04003952,1.66678892 5.04708054,1.89508431 C5.03336907,2.13201969 5.13157284,2.36330585 5.31945702,2.53544123 C5.5073412,2.70757662 5.76822969,2.80527595 6.04097675,2.80527595 C6.30927685,2.80560738 6.56571837,2.71056738 6.75174965,2.54208738 C6.93741035,2.37393969 7.03635528,2.14697354 7.02523787,1.91369354 C7.03635528,1.67841969 6.93629861,1.44945969 6.74878501,1.27931815 C6.56127141,1.10950892 6.30186524,1.01380431 6.03134166,1.01380431 M6.03134166,0.209952 C6.55904793,0.194998154 7.07081924,0.368462769 7.44806993,0.689472 C7.82495003,1.01114585 8.03506903,1.45245046 8.02876917,1.91169969 C8.02876917,2.37327508 7.81494437,2.81524431 7.4354702,3.13791508 C7.05599603,3.46058585 6.5427424,3.63670892 6.01207149,3.62607508 C5.48288291,3.64102892 4.96962927,3.46656738 4.59200801,3.143232 C4.21475732,2.82022892 4.00575006,2.37659815 4.01464399,1.91568738 C4.01649689,1.45544123 4.23143343,1.01513354 4.61053702,0.694124308 C4.99001119,0.373115077 5.50215308,0.198653538 6.03134166,0.209952 M3.19158527,0.208955077 C3.33129402,0.208955077 3.46544407,0.253816615 3.56401842,0.333570462 C3.66259276,0.413324308 3.71743864,0.521656615 3.71669747,0.634308923 L3.71669747,3.17413662 C3.72114444,3.29077662 3.6655574,3.40376123 3.56327725,3.48617354 C3.46062653,3.56891815 3.3205472,3.61344738 3.17565032,3.609792 L3.14674506,3.609792 C2.934032,3.60513969 2.73762448,3.51641354 2.62163286,3.37318892 L1.07186629,1.73690585 L1.07186629,3.195072 C1.07186629,3.43366892 0.832100874,3.62673969 0.536007261,3.62673969 C0.240284229,3.62673969 0.000148232097,3.43366892 0.000148232097,3.195072 L0.000148232097,0.655576615 C-0.0042987308,0.538604308 0.0512883054,0.425619692 0.153939032,0.343207385 C0.256219179,0.260795077 0.396669091,0.215933538 0.541565965,0.219256615 L0.643475531,0.219256615 C0.85655917,0.224241231 1.05259612,0.312967385 1.16895831,0.456524308 L2.66610249,2.02069662 L2.66610249,0.632315077 C2.66610249,0.398370462 2.90142094,0.208955077 3.19158527,0.208955077 M13.8209383,0.355170462 C13.9202538,0.433595077 13.9762115,0.540930462 13.9762115,0.652918154 C13.9732468,0.707748923 13.9599059,0.761582769 13.9373005,0.813090462 L12.8426065,3.28944738 C12.7725668,3.48517662 12.5524422,3.62208738 12.2993359,3.62673969 L12.2111378,3.62673969 C11.9532139,3.62408123 11.7304952,3.48052431 11.6700906,3.27881354 L11.0026756,1.721952 L10.33489,3.28712123 C10.2707796,3.48517662 10.050655,3.62408123 9.79643692,3.62673969 L9.7086094,3.62673969 C9.44735033,3.62175508 9.2227787,3.47686892 9.15978006,3.27249969 L8.06768009,0.807108923 C8.04470412,0.756930462 8.03136323,0.704093538 8.02876917,0.650592 C8.02876917,0.536278154 8.08657968,0.427281231 8.18960099,0.348524308 C8.29225172,0.269435077 8.43084873,0.228228923 8.57241038,0.233878154 C8.80995232,0.232881231 9.02007131,0.357164308 9.0897404,0.540265846 L9.76530818,2.20745354 L10.44347,0.540265846 C10.5086921,0.345865846 10.7265933,0.210284308 10.976735,0.208925426 L11.04381,0.208925426 C11.2950634,0.207293538 11.5151881,0.344204308 11.577075,0.540265846 L12.2548662,2.20745354 L12.930434,0.540265846 C12.9952856,0.354838154 13.2091104,0.228893538 13.4481346,0.236204308 C13.5874728,0.233545846 13.7216228,0.276745846 13.8209383,0.355170462 Z",
    id: "Fill-10",
    fill: "#4A245F",
    mask: "url(#mask-7)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.344f01747a13ec03b467518734c1441d.svg";
export { ForwardRef as ReactComponent };